

































import {Vue, Component, Prop} from 'vue-property-decorator';
import {ExplorerView} from '@/types';

@Component({})
export default class ShareViewCard extends Vue {
  @Prop() private view!: ExplorerView;
  private isPublic: boolean = false;

  private mounted() {
    this.isPublic = this.view.is_public;
  }
}
